import { render, staticRenderFns } from "./PartnerCourseTable.vue?vue&type=template&id=278c0f78&scoped=true"
import script from "./PartnerCourseTable.vue?vue&type=script&lang=js"
export * from "./PartnerCourseTable.vue?vue&type=script&lang=js"
import style0 from "./PartnerCourseTable.vue?vue&type=style&index=0&id=278c0f78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278c0f78",
  null
  
)

export default component.exports